// Small shared utilities
export function fmtCurrency(n, currency = "EUR") {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-IE", {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
    }).format(n);
}

export function fmtPct(n) {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return `${n}%`;
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return iso;
    }
}

export function fmtTime(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "";
    }
}

export function todayISO() {
    const d = new Date();
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
}

export function addDays(iso, days) {
    const d = new Date(iso);
    d.setDate(d.getDate() + days);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
}
